import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import Swal from 'sweetalert2';

import { ModalCancelarConstatacaoComponent } from './modal-cancelar-matriz-constatacao/modal-cancelar-matriz-constatacao.component';

import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import {
  IConstatacaoModel,
  IManifestacaoAuditadoModel, IMatrizConsolidadaUgSecaoVM,
  IMatrizConstatacaoModel, IMatrizDefinitivaConsolidadaResponse, IOsaExecucaoMatrizConstatacaoItemModel, IStatusModel,
  StatusConstatacao,
  StatusManifestacao,
  StatusMatriz
} from "../../../../models/constatacao.model";
import { AuthService } from "../../../../services/auth.service";
import { SharedService } from "../../../../services/shared.service";
import { EnumRecursoPerfil } from "../../../../models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "../../../../models/enum/acao-recurso.enum";
import { MatrizConstatacoesService } from "../../../../services/matriz-constatacao.service";
import { ModalEditarConstatacaoComponent } from "./modal-editar-constatacao/modal-editar-constatacao.component";
import {
  ModalAprovarMatrizComponent
} from "./modal-aprovar-matriz-constatacao/modal-aprovar-matriz-constatacao.component";
import { ModalEditarManifestacaoComponent } from "./modal-editar-manifestacao/modal-editar-manifestacao.component";
import { ModalAvaliarManifestacaoComponent } from "./modal-avaliar-manifestacao/modal-avaliar-manifestacao.component";
import {
  ModalVisualizarMatrizComponent
} from "./modal-visualizar-matriz-contatacao/modal-visualizar-matriz-constatacao.component";
import { StatusManifestacaoAuditado } from "../../../../models/enum/status-manifestacao-auditado";
import { IOsaExecucaoFolhaTesteQuestaoModel } from "../../../../models/osa-execucao-folha-teste-model";
import {
  OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent
} from "../osa-execucao-aba-folha-teste/osa-execucao-aba-folha-teste-questao-historico/osa-execucao-aba-folha-teste-questao-historico.component";
import {
  ModalHistoricoMatrizConstatacaoComponent
} from "./modal-historico-matriz-constatacao/modal-historico-matriz-constatacao.component";
import { INotaAuditoriaExecucaoModel } from "../../../../models/nota-auditoria-execucao.model";

@Component({
  selector: 'app-osa-execucao-aba-matriz-constatacao',
  templateUrl: './osa-execucao-aba-matriz-constatacao.component.html',
  styleUrls: ['./osa-execucao-aba-matriz-constatacao.component.scss']
})
export class OsaExecucaoAbaMatrizConstatacaoComponent extends BaseFormComponent implements OnInit {

  public displayedColumnsConsolidada: string[] = [
    'constacao',
    'responsavel',
    'dataFinalizacao',
    'status',
    'acoes'
  ];

  public displayedColumnsPreliminar: string[] = [
    'constacao',
    'responsavel',
    'dataFinalizacao',
    'status',
    'acoes'
  ];

  public displayedColumnsDefinitiva: string[] = [
    'constacao',
    'responsavel',
    'dataFinalizacao',
    'status',
    'acoes'
  ];

  displayedColumnsManifestacao: string[] = ['nome', 'responsavel', 'dataFinalizacao', 'status', 'acoes'];

  public dataSourcePreliminar = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>([]);
  public dataSourceManifestacao = new MatTableDataSource<IManifestacaoAuditadoModel>([]);
  public dataSourceDefinitiva = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>([]);
  public selectedItemPreliminar: IOsaExecucaoMatrizConstatacaoItemModel | null = null;
  public matrizDefinitivaConsolidada: IMatrizDefinitivaConsolidadaResponse | null = null;
  public secoesConsolidadasVM: IMatrizConsolidadaUgSecaoVM[] = [];
  public matrizPreliminar: IMatrizConstatacaoModel | null = null;
  public matrizDefinitiva: IMatrizConstatacaoModel | null = null;
  public matrizConsolidada: IMatrizConstatacaoModel | null = null;
  public manifestacaoAuditado: IManifestacaoAuditadoModel | null = null;

  public selectedConstatacaoPreliminar: IConstatacaoModel | null = null;
  public selectedConstatacaoDefinitiva: IConstatacaoModel | null = null;

  public semDadosPreliminar = true;
  public semDadosDefinitiva = true;
  public dataAtual = new Date();

  public podePlanejar = false;
  public podeAprovarMatriz = false;
  public podeEditarManifestacaoFlag = false;
  public podeEditarConstatacao = false;
  public podeVisualizarMatriz = false;

  public mostrarSecaoPreliminar = false;
  public mostrarSecaoManifestacao = false;
  public mostrarSecaoDefinitiva = false;
  public mostrarSecaoConsolidada = false;
  public titulo: string = '';

  public StatusMatrizConstatacao = {
    NaoIniciada: 1,
    EmElaboracao: 2,
    Finalizada: 3,
    Aprovada: 4,
    Rejeitada: 5
  };

  public StatusMatriz = StatusMatriz;
  public StatusConstatacao = StatusConstatacao;
  public StatusManifestacao = StatusManifestacao;

  @Input() public visualizar = false;
  @Input() public osaExecucaoId: number;
  @Input() public osaMatrizExecucaoId: number;

  @ViewChild('paginatorPreliminar', { static: false }) paginatorPreliminar: MatPaginator;
  @ViewChild('sortPreliminar', { static: false }) sortPreliminar: MatSort;
  @ViewChild('paginatorDefinitiva', { static: false }) paginatorDefinitiva: MatPaginator;
  @ViewChild('sortDefinitiva', { static: false }) sortDefinitiva: MatSort;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    public authService: AuthService,
    public matrizConstatacoesService: MatrizConstatacoesService,
    public sharedService: SharedService,
    localeService: BsLocaleService,
    public matDialog: MatDialog
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.titulo = 'Matriz de Constatações';
  }

  ngOnInit(): void {
    this.setarPermissoes();
    this.osaExecucaoId = this.id || this.osaExecucaoId;

    if (this.visualizar) {
      this.titulo = 'Visualizar Matriz de Constatações';
    }

    this.carregarDados();
  }

  private setarPermissoes(): void {
    this.podePlanejar = this.authService.possuiPermissao(
      EnumRecursoPerfil.AuditoriaExecucao,
      EnumAcaoRecurso.Executar
    );

    this.podeAprovarMatriz = this.authService.possuiPermissao(
      EnumRecursoPerfil.AuditoriaExecucao,
      EnumAcaoRecurso.AprovarMatrizPreliminar
    );

    this.podeVisualizarMatriz = this.authService.possuiPermissao(
      EnumRecursoPerfil.AuditoriaExecucao,
      EnumAcaoRecurso.Executar
    );
  }

  // ==================== CARREGAMENTO DE DADOS ====================

  private carregarDados(): void {
    this.carregarMatrizPreliminar();
    this.carregarMatrizDefinitiva();
    this.carregarMatrizDefinitivaConsolidada();
  }

  private carregarMatrizPreliminar(): void {
    this.matrizConstatacoesService.obterMatrizPreliminar(this.osaExecucaoId)
      .then((res) => {
        if (res && res.sucesso && res.dados) {
          this.matrizPreliminar = res.dados;
          this.mostrarSecaoPreliminar = true;
          this.osaMatrizExecucaoId = res.dados.id;
          //-> Crit 21/23: publica o status p/ a aba PT/Folhas bloquear sem F5 + recarrega PT/folhas
          try {
            this.sharedService.setStatusMatrizPreliminar(res.dados.status ?? null);
            this.sharedService.sendSincronizarDadosEvent();
          } catch {}
          this.carregarManifestacaoAuditado(this.osaMatrizExecucaoId);

          if (this.matrizPreliminar.itens && this.matrizPreliminar.itens.length > 0) {
            this.dataSourcePreliminar = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(
              this.matrizPreliminar.itens
            );
            this.semDadosPreliminar = false;
            setTimeout(() => this.configurarTabelaPreliminar());
          } else {
            this.semDadosPreliminar = true;
          }
        } else {
          //-> sem matriz preliminar (ex.: após Habilitar PT): limpa a seção e desbloqueia PT/folhas
          this.resetarPreliminar();
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao carregar Matriz Preliminar');
      });
  }

  public getStatusMatrizDescricao(statusCodigo: number | undefined): string {
    if (!statusCodigo) return 'Desconhecido';
    switch (statusCodigo) {
      case 1: return 'Não iniciada';
      case 2: return 'Em Elaboração';
      case 3: return 'Finalizada';
      case 4: return 'Aprovada';
      case 5: return 'Rejeitada';
      default: return 'Desconhecido';
    }
  }

  public getStatusManifestacaoDescricao(status: number | undefined): string {
    if (!status) return 'Desconhecido';
    switch (status) {
      case 1: return 'Não iniciada';
      case 2: return 'Em Elaboração';
      case 3: return 'Enviado';
      case 4: return 'Com sugestões acatadas';
      case 5: return 'Com sugestões não acatadas';
      case 6: return 'Sem sugestões';
      default: return 'Desconhecido';
    }
  }

  public getStatusMatrizClass(statusCodigo: number | undefined): string {
    if (!statusCodigo) return 'badge bg-secondary text-xs';
    switch (statusCodigo) {
      case 1: return 'badge bg-secondary text-xs';
      case 2: return 'badge bg-success text-xs';
      case 3: return 'badge bg-warning text-xs';
      case 4: return 'badge bg-primary text-xs';
      case 5: return 'badge bg-danger text-xs';
      default: return 'badge bg-secondary text-xs';
    }
  }

  public podeHabilitarPT(): boolean {
    if (this.visualizar) return false;
    if (!this.podePlanejar) return false;
    //-> Crit 23-26: botão disponível somente quando Rejeitada
    return this.matrizPreliminar?.status === this.StatusMatrizConstatacao.Rejeitada;
  }

  public habilitarPT(): void {
    Swal.fire({
      title: 'Habilitar Programa de Trabalho',
      text: 'Essa ação implica na perda dos dados inseridos nas constatações da Matriz Preliminar, pois a matriz deverá ser gerada novamente após as atualizações do PT e Folhas testes. Deseja prosseguir com a ação?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, habilitar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.matrizConstatacoesService.habilitarProgramaTrabalho(this.osaExecucaoId)
          .then((res) => {
            if (res.sucesso) {
              this.exibirSucesso('Programa de Trabalho habilitado com sucesso');
              //-> Crit 26a/26d: limpa a seção preliminar na hora (sem F5), recarrega demais
              //-> seções e propaga desbloqueio + reload de PT/folhas (Em Elaboração)
              this.resetarPreliminar();
              this.carregarDados();
              try {
                this.sharedService.setStatusMatrizPreliminar(null);
                this.sharedService.sendSincronizarDadosEvent();
              } catch {}
            } else {
              this.exibirAviso(res?.mensagem?.descricao || 'Erro ao habilitar o Programa de Trabalho');
            }
          })
          .catch((err) => {
            this.exibirErro(err?.mensagem?.descricao || 'Erro ao habilitar o Programa de Trabalho');
          });
      }
    });
  }

  // ✅ Novo método para visualizar por ID direto (seções da consolidada)
  public visualizarMatrizPorId(
    matrizId: number,
    tipoMatriz: 'preliminar' | 'definitiva' | 'consolidada',
    titulo: string,
    nomeUnidade: string
  ): void {
    if (!matrizId) {
      this.exibirAviso('Matriz não encontrada');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-matriz';
    dialogConfig.width = '95%';
    dialogConfig.height = '95vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      nomeUnidade,
      matrizId,
      tipoMatriz,
      osaExecucaoId: this.osaExecucaoId,
      numeroOsa: this.sharedService.getNumeroOsa()
    };

    this.matDialog.open(ModalVisualizarMatrizComponent, dialogConfig);
  }

  public getStatusItemDescricao(statusCodigo: number | undefined): string {
    if (!statusCodigo) return 'Desconhecido';
    switch (statusCodigo) {
      case 1: return 'Não Iniciada';
      case 2: return 'Em Elaboração';
      case 3: return 'Finalizada';
      case 4: return 'Cancelada';
      default: return 'Desconhecido';
    }
  }

  public getStatusItemClass(statusCodigo: number | undefined): string {
    if (!statusCodigo) return 'badge bg-secondary text-xs';
    switch (statusCodigo) {
      case 1: return 'badge bg-secondary text-xs';
      case 2: return 'badge bg-success text-xs';
      case 3: return 'badge bg-warning text-xs';
      case 4: return 'badge bg-danger text-xs';
      default: return 'badge bg-secondary text-xs';
    }
  }

  private carregarManifestacaoAuditado(id: number): void {
    this.matrizConstatacoesService.obterManifestacaoAuditado(id)
      .then((res) => {
        if (res && res.sucesso && res.dados) {
          this.manifestacaoAuditado = res.dados;
          this.mostrarSecaoManifestacao = true;
          this.dataSourceManifestacao = new MatTableDataSource<IManifestacaoAuditadoModel>([res.dados]);
          this.sharedService.setStatusManifestacao(res.dados.status);
        } else {
          this.dataSourceManifestacao = new MatTableDataSource<IManifestacaoAuditadoModel>([]);
          this.sharedService.setStatusManifestacao(null);
        }
      })
      .catch(() => {
        this.dataSourceManifestacao = new MatTableDataSource<IManifestacaoAuditadoModel>([]);
        this.sharedService.setStatusManifestacao(null);
      });
  }

  private carregarMatrizDefinitiva(): void {
    this.matrizConstatacoesService.obterMatrizDefinitiva(this.osaExecucaoId)
      .then((res) => {
        if (res?.sucesso && res?.dados) {
          this.matrizDefinitiva = res.dados;
          this.mostrarSecaoDefinitiva = true;

          const itens = this.matrizDefinitiva.itens || [];
          this.dataSourceDefinitiva = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(itens);
          this.semDadosDefinitiva = itens.length === 0;

          setTimeout(() => this.configurarTabelaDefinitiva());
        } else {
          this.resetarDefinitiva();
        }
      })
      .catch(() => this.resetarDefinitiva());
  }

  private carregarMatrizDefinitivaConsolidada(): void {
    this.matrizConstatacoesService.obterMatrizDefinitivaConsolidada(this.osaExecucaoId)
      .then((res) => {
        if (res?.sucesso && res?.dados) {
          this.matrizDefinitivaConsolidada = res.dados;
          this.mostrarSecaoConsolidada = true;

          const secoes = this.matrizDefinitivaConsolidada.secoes || [];
          this.secoesConsolidadasVM = secoes.map((s, idx) => {
            const itens = s.itensFinalizados || [];
            return {
              ...s,
              headingId: `heading-consolidada-ug-${idx}`,
              collapseId: `collapse-consolidada-ug-${idx}`,
              dataSource: new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(itens),
              semDados: itens.length === 0
            };
          });
        } else {
          this.resetarConsolidada();
        }
      })
      .catch(() => this.resetarConsolidada());
  }

  private resetarConsolidada(): void {
    this.matrizDefinitivaConsolidada = null;
    this.secoesConsolidadasVM = [];
    this.mostrarSecaoConsolidada = false;
  }

  private resetarDefinitiva(): void {
    this.matrizDefinitiva = null;
    this.mostrarSecaoDefinitiva = false;
    this.dataSourceDefinitiva = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>([]);
    this.semDadosDefinitiva = true;
  }

  //-> Crit 26a: limpa a seção preliminar imediatamente (sem F5) após Habilitar PT excluir a matriz
  private resetarPreliminar(): void {
    this.matrizPreliminar = null;
    this.mostrarSecaoPreliminar = false;
    this.dataSourcePreliminar = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>([]);
    this.semDadosPreliminar = true;
    this.selectedItemPreliminar = null;
    this.selectedConstatacaoPreliminar = null;
    this.osaMatrizExecucaoId = null;
    try { this.sharedService.setStatusMatrizPreliminar(null); } catch {}
  }

  private carregarMatrizConsolidada(): void {
    this.matrizConstatacoesService.obterMatrizConsolidada(this.osaExecucaoId)
      .then((res) => {
        if (res && res.sucesso && res.dados) {
          this.matrizConsolidada = res.dados;
          this.mostrarSecaoConsolidada = true;
        }
      })
      .catch((err) => {
        console.log('Matriz Consolidada não encontrada ou erro:', err);
      });
  }

  private configurarTabelaPreliminar(): void {
    if (this.paginatorPreliminar && this.sortPreliminar) {
      this.dataSourcePreliminar.paginator = this.paginatorPreliminar;
      this.dataSourcePreliminar.sort = this.sortPreliminar;
      this.dataSourcePreliminar.sortingDataAccessor = this.sortingDataAccessor;
    }
  }

  private configurarTabelaDefinitiva(): void {
    if (this.paginatorDefinitiva) {
      this.dataSourceDefinitiva.paginator = this.paginatorDefinitiva;
    }
    if (this.sortDefinitiva) {
      this.dataSourceDefinitiva.sort = this.sortDefinitiva;
      this.dataSourceDefinitiva.sortingDataAccessor = this.sortingDataAccessor;
    }
  }

  private podeEditarCancelarDefinitiva(): boolean {
    if (this.visualizar) return false;
    if (!this.podePlanejar) return false;
    return this.manifestacaoAuditado?.status === StatusManifestacaoAuditado.ComSugestoesAcatadas;
  }

  public podeEditarItemDefinitiva(item: any): boolean {
    if (!this.podeEditarCancelarDefinitiva()) return false;
    const statusPermitidos = [1, 2];
    return statusPermitidos.includes(item.status);
  }

  public podeCancelarItemDefinitiva(item: any): boolean {
    if (!this.podeEditarCancelarDefinitiva()) return false;
    return item.status !== 4;
  }

  public podeAtivarItemDefinitiva(item: IOsaExecucaoMatrizConstatacaoItemModel): boolean {
    if (!this.podeEditarMatrizDefinitiva()) return false;
    if (this.matrizConsolidada) return false;
    return item?.status === 4;
  }

  public abrirModalCancelarConstatacao(item: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-cancelar-constatacao-definitiva';
    dialogConfig.width = '600px';
    dialogConfig.height = '40vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      constatacaoId: item.id,
      identificador: item.identificador,
      descricao: item.descricaoConstatacao
    };

    const modal = this.matDialog.open(ModalCancelarConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarMatrizDefinitiva();
        this.selectedConstatacaoDefinitiva = null;
      }
    });
  }

  public editarItemDefinitivo(item?: any, visualizarItem: boolean = false): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-editar-item-definitivo';
    dialogConfig.panelClass = 'dialog-constatacao-item';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: visualizarItem ? 'Visualizar Item da Matriz' : 'Editar Item da Matriz',
      element: item,
      matrizId: this.matrizDefinitiva?.id,
      tipoMatriz: 'definitiva',
      visualizar: visualizarItem,
      osaExecucaoId: this.osaExecucaoId
    };

    const modal = this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarMatrizDefinitiva();
      }
    });
  }

  public sortingDataAccessor = (item: IOsaExecucaoMatrizConstatacaoItemModel, property: string) => {
    switch (property) {
      case 'id': return item?.id;
      case 'questaoId': return item?.osaExecucaoProgramaTrabalhoQuestaoConstatacaoId;
      case 'situacaoEncontrada': return item?.situacaoEncontrada || '';
      case 'causa': return item?.causa || '';
      case 'efeito': return item?.efeito || '';
      case 'status': return item?.status;
      default: return (item as any)[property];
    }
  };

  public podeEditarMatrizDefinitiva(): boolean {
    if (this.visualizar) return false;
    if (!this.podePlanejar) return false;
    return this.manifestacaoAuditado?.status === StatusManifestacaoAuditado.ComSugestoesAcatadas;
  }

  public selecionarConstatacaoDefinitivaRow(row: IConstatacaoModel): void {
    this.selectedConstatacaoDefinitiva =
      !this.selectedConstatacaoDefinitiva || this.selectedConstatacaoDefinitiva.id !== row.id
        ? row
        : null;
  }

  // ==================== GERAR MATRIZ PRELIMINAR ====================

  public gerarMatrizPreliminar(): void {
    this.matrizConstatacoesService
      .validarProgramaTrabalho(this.osaExecucaoId)
      .then(res => {
        if (!res?.sucesso || res?.dados?.podeGerar !== true) {
          this.exibirAviso('O Programa de Trabalho e/ou folhas testes não estão finalizados');
          return;
        }

        const statusMan = this.manifestacaoAuditado?.status;
        const statusPermitidos = [StatusManifestacao.NaoIniciada, StatusManifestacao.EmElaboracao];

        if (statusMan != null && !statusPermitidos.includes(statusMan)) {
          this.exibirAviso('Não é permitido gerar Matriz enquanto a Manifestação do Auditado não estiver em "Não iniciada" ou "Em Elaboração".');
          return;
        }

        this.confirmarGeracaoMatriz();
      })
      .catch(() => this.exibirErro('Erro ao validar Programa de Trabalho'));
  }

  public editarItemPreliminar(item?: IOsaExecucaoMatrizConstatacaoItemModel, visualizarItem: boolean = false): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-editar-item-preliminar';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Editar Item da Matriz',
      element: item,
      matrizId: this.matrizPreliminar?.id,
      tipoMatriz: 'preliminar',
      visualizar: visualizarItem,
      osaExecucaoId: this.osaExecucaoId
    };

    const modal = this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarMatrizPreliminar();
        this.selectedItemPreliminar = null;
      }
    });
  }

  public visualizarItemPreliminar(item?: IOsaExecucaoMatrizConstatacaoItemModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-item-preliminar';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Visualizar Item da Matriz',
      item: item || this.selectedItemPreliminar,
      matrizId: this.matrizPreliminar?.id,
      tipoMatriz: 'preliminar',
      visualizar: true,
      osaExecucaoId: this.osaExecucaoId
    };

    this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
  }

  public selecionarItemPreliminar(item: IOsaExecucaoMatrizConstatacaoItemModel): void {
    this.selectedItemPreliminar =
      !this.selectedItemPreliminar || this.selectedItemPreliminar.id !== item.id
        ? item
        : null;
  }

  public podeEditarItemPreliminar(): boolean {
    if (this.visualizar) return false;
    if (!this.selectedItemPreliminar) return false;
    if (!this.podePlanejar) return false;
    const statusPermitidos = [1, 2];
    return statusPermitidos.includes(this.selectedItemPreliminar.status);
  }

  public podeEditarItem(item: IOsaExecucaoMatrizConstatacaoItemModel): boolean {
    if (this.visualizar) return false;
    if (!this.podePlanejar) return false;
    const statusPermitidos = [1, 2];
    return statusPermitidos.includes(item.status);
  }

  private confirmarGeracaoMatriz(): void {
    if (this.matrizPreliminar && this.matrizPreliminar.id) {
      Swal.fire({
        title: 'Atenção',
        text: 'Já existe Matriz Preliminar Gerada. A geração de uma nova Matriz irá apagar as constatações já iniciadas ou finalizadas',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, gerar nova matriz',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.executarGeracaoMatriz(true);
        }
      });
    } else {
      this.executarGeracaoMatriz(false);
    }
  }

  private executarGeracaoMatriz(forcarRegeneracao: boolean): void {
    this.matrizConstatacoesService
      .gerarMatrizPreliminar(this.osaExecucaoId, forcarRegeneracao)
      .then((res) => {
        if (res && res.sucesso) {
          this.exibirSucesso('Matriz Preliminar gerada com sucesso');
          this.manifestacaoAuditado = null;
          this.mostrarSecaoManifestacao = false;
          this.dataSourceManifestacao = new MatTableDataSource<IManifestacaoAuditadoModel>([]);
          this.carregarMatrizPreliminar();
        } else {
          this.exibirAviso(res?.mensagem?.descricao || 'Erro ao gerar Matriz Preliminar');
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao gerar Matriz Preliminar');
      });
  }

  // ==================== SELEÇÃO DE CONSTATAÇÕES ====================

  public selecionarConstatacaoPreliminar(constatacao: IConstatacaoModel): void {
    this.selectedConstatacaoPreliminar =
      !this.selectedConstatacaoPreliminar || this.selectedConstatacaoPreliminar.id !== constatacao.id
        ? constatacao
        : null;
  }

  public selecionarConstatacaoDefinitiva(constatacao: IConstatacaoModel): void {
    this.selectedConstatacaoDefinitiva =
      !this.selectedConstatacaoDefinitiva || this.selectedConstatacaoDefinitiva.id !== constatacao.id
        ? constatacao
        : null;
  }

  public permiteEditarDefinitiva(): boolean {
    const st = this.manifestacaoAuditado?.status;
    return st === StatusManifestacaoAuditado.ComSugestoesAcatadas;
  }

  public definitivaSomenteLeitura(): boolean {
    const st = this.manifestacaoAuditado?.status;
    return st === StatusManifestacaoAuditado.ComSugestoesNaoAcatadas
      || st === StatusManifestacaoAuditado.SemSugestoes;
  }

  // ==================== AÇÕES DA MATRIZ PRELIMINAR ====================

  public editarConstatacaoPreliminar(constatacao?: IConstatacaoModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-editar-constatacao-preliminar';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Editar Constatação',
      constatacao: constatacao || this.selectedConstatacaoPreliminar,
      matrizId: this.matrizPreliminar?.id,
      tipoMatriz: 'preliminar',
      visualizar: this.visualizar,
      osaExecucaoId: this.osaExecucaoId
    };

    const modal = this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarMatrizPreliminar();
        this.selectedConstatacaoPreliminar = null;
      }
    });
  }

  public visualizarConstatacaoPreliminar(constatacao?: IConstatacaoModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-constatacao-preliminar';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Visualizar Constatação',
      constatacao: constatacao || this.selectedConstatacaoPreliminar,
      matrizId: this.matrizPreliminar?.id,
      tipoMatriz: 'preliminar',
      visualizar: true,
      osaExecucaoId: this.osaExecucaoId
    };

    this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
  }

  public aprovarMatrizPreliminar(): void {
    if (!this.podeAprovarMatriz) {
      this.exibirAviso('Você não possui permissão para aprovar a Matriz Preliminar');
      return;
    }

    if (this.matrizPreliminar?.status !== 3) {
      this.exibirAviso('A Matriz Preliminar não está finalizada!');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aprovar-matriz-preliminar';
    dialogConfig.width = '600px';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      matrizId: this.matrizPreliminar.id,
      osaExecucaoId: this.osaExecucaoId
    };

    const modal = this.matDialog.open(ModalAprovarMatrizComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        //-> Crit 26: refresh imediato + propaga bloqueio p/ PT (sem precisar sair/entrar)
        this.carregarDados();
        try { this.sharedService.sendSincronizarDadosEvent(); } catch {}
      }
    });
  }

  // ==================== MANIFESTAÇÃO DO AUDITADO ====================

  public editarManifestacaoAuditado(element: any, podeEditar: boolean = false): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-editar-manifestacao-auditado';
    dialogConfig.panelClass = 'dialog-manifestacao-auditado';
    dialogConfig.width = '100%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.restoreFocus = false;
    dialogConfig.data = {
      titulo: 'Editar Manifestação do Auditado',
      manifestacao: this.manifestacaoAuditado,
      osaMatrizExecucaoId: this.osaMatrizExecucaoId,
      id: element.id,
      numeroOsa: this.sharedService.getNumeroOsa(),
      visualizar: podeEditar,
      onSaved: () => {
        this.carregarManifestacaoAuditado(this.osaMatrizExecucaoId);
      }
    };

    const modal = this.matDialog.open(ModalEditarManifestacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarDados();
      }
    });
  }

  public visualizarManifestacaoAuditado(element: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-manifestacao-auditado';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Visualizar Manifestação do Auditado',
      manifestacao: this.manifestacaoAuditado,
      osaExecucaoId: this.osaExecucaoId,
      numeroOsa: this.sharedService.getNumeroOsa(),
      visualizar: true
    };

    this.matDialog.open(ModalEditarManifestacaoComponent, dialogConfig);
  }

  public avaliarManifestacaoAuditado(element: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-avaliar-manifestacao-auditado';
    dialogConfig.width = '600px';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.id,
      manifestacao: element,
      osaExecucaoId: this.osaExecucaoId,
      onEvaluated: () => {
        this.carregarManifestacaoAuditado(this.osaMatrizExecucaoId);
        this.carregarMatrizDefinitiva();
      }
    };

    const modal = this.matDialog.open(ModalAvaliarManifestacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarDados();
      }
    });
  }

  // ==================== AÇÕES DA MATRIZ DEFINITIVA ====================

  public editarConstatacaoDefinitiva(constatacao?: IConstatacaoModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-editar-constatacao-definitiva';
    dialogConfig.width = '90%';
    dialogConfig.height = '90vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: 'Editar Constatação Definitiva',
      constatacao: constatacao || this.selectedConstatacaoDefinitiva,
      matrizId: this.matrizDefinitiva?.id,
      tipoMatriz: 'definitiva',
      visualizar: this.visualizar,
      osaExecucaoId: this.osaExecucaoId
    };

    const modal = this.matDialog.open(ModalEditarConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((resultado) => {
      if (resultado) {
        this.carregarMatrizDefinitiva();
        this.selectedConstatacaoDefinitiva = null;
      }
    });
  }

  public ativarConstatacaoDefinitiva(constatacao: IConstatacaoModel): void {
    Swal.fire({
      title: 'Ativar Constatação',
      text: 'Deseja realmente ativar esta constatação?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, ativar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.matrizConstatacoesService.ativarConstatacao(constatacao.id, this.authService.usuario.id)
          .then((res) => {
            if (res && res.sucesso) {
              this.exibirSucesso('Constatação ativada com sucesso');
              this.carregarMatrizDefinitiva();
            } else {
              this.exibirAviso(res?.mensagem?.descricao || 'Erro ao ativar constatação');
            }
          })
          .catch((err) => {
            this.exibirErro(err?.mensagem?.descricao || 'Erro ao ativar constatação');
          });
      }
    });
  }

  // ==================== VISUALIZAR/IMPRIMIR MATRIZES ====================

  public visualizarImprimirMatriz(tipoMatriz: 'preliminar' | 'definitiva' | 'consolidada'): void {

    console.log(this.matrizConsolidada?.id);
    let matrizId: number | undefined;
    let titulo: string;

    switch (tipoMatriz) {
      case 'preliminar':
        matrizId = this.matrizPreliminar?.id;
        titulo = 'Matriz de Constatações Preliminar';
        break;
      case 'definitiva':
        matrizId = this.matrizDefinitiva?.id;
        titulo = 'Matriz de Constatações Definitiva';
        break;
      case 'consolidada':
        matrizId = this.matrizConsolidada?.id;
        titulo = 'Matriz de Constatações Consolidada';
        break;
    }

    if (!matrizId) {
      this.exibirAviso('Matriz não encontrada');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-matriz';
    dialogConfig.width = '95%';
    dialogConfig.height = '95vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      matrizId,
      tipoMatriz,
      osaExecucaoId: this.osaExecucaoId,
      numeroOsa: this.sharedService.getNumeroOsa()
    };

    this.matDialog.open(ModalVisualizarMatrizComponent, dialogConfig);
  }

  // ==================== MATRIZ CONSOLIDADA ====================

  public gerarMatrizConsolidada(): void {
    this.matrizConstatacoesService.validarMatrizesDefinitivas(this.osaExecucaoId)
      .then((res) => {
        if (res && res.sucesso && res.dados?.todasFinalizadas) {
          return this.matrizConstatacoesService.gerarMatrizConsolidada(this.osaExecucaoId);
        } else if (res?.dados?.ugSubsidiariasPendentes) {
          this.exibirAviso('A Matriz Definitiva da UG Subsidiária não está finalizada');
          return null;
        } else {
          this.exibirAviso('A Matriz de Constatação Definitiva não está finalizada');
          return null;
        }
      })
      .then((res) => {
        if (!res) return;

        if (res.sucesso) {
          this.exibirSucesso('Matriz Consolidada gerada com sucesso');
          Promise.all([
            this.carregarMatrizPreliminarAsync(),
            this.carregarMatrizDefinitivaAsync(),
            this.carregarMatrizDefinitivaConsolidadaAsync()
          ]);
        } else {
          this.exibirAviso(res?.mensagem?.descricao || 'Erro ao gerar Matriz Consolidada');
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro na geração da Matriz Consolidada');
      });
  }

  private carregarMatrizPreliminarAsync(): Promise<void> {
    return this.matrizConstatacoesService.obterMatrizPreliminar(this.osaExecucaoId)
      .then((res) => {
        if (res && res.sucesso && res.dados) {
          this.matrizPreliminar = res.dados;
          this.mostrarSecaoPreliminar = true;
          this.osaMatrizExecucaoId = res.dados.id;
          //-> Crit 21/23: publica o status p/ a aba PT/Folhas bloquear sem F5 + recarrega PT/folhas
          try {
            this.sharedService.setStatusMatrizPreliminar(res.dados.status ?? null);
            this.sharedService.sendSincronizarDadosEvent();
          } catch {}
          this.carregarManifestacaoAuditado(this.osaMatrizExecucaoId);

          if (this.matrizPreliminar.itens && this.matrizPreliminar.itens.length > 0) {
            this.dataSourcePreliminar = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(
              this.matrizPreliminar.itens
            );
            this.semDadosPreliminar = false;
            setTimeout(() => this.configurarTabelaPreliminar());
          } else {
            this.semDadosPreliminar = true;
          }
        } else {
          //-> sem matriz preliminar (ex.: após Habilitar PT): limpa a seção e desbloqueia PT/folhas
          this.resetarPreliminar();
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao carregar Matriz Preliminar');
      });
  }

  private carregarMatrizDefinitivaAsync(): Promise<void> {
    return this.matrizConstatacoesService.obterMatrizDefinitiva(this.osaExecucaoId)
      .then((res) => {
        if (res?.sucesso && res?.dados) {
          this.matrizDefinitiva = res.dados;
          this.mostrarSecaoDefinitiva = true;

          const itens = this.matrizDefinitiva.itens || [];
          this.dataSourceDefinitiva = new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(itens);
          this.semDadosDefinitiva = itens.length === 0;

          setTimeout(() => this.configurarTabelaDefinitiva());
        } else {
          this.resetarDefinitiva();
        }
      })
      .catch(() => this.resetarDefinitiva());
  }

  private carregarMatrizDefinitivaConsolidadaAsync(): Promise<void> {
    return this.matrizConstatacoesService.obterMatrizDefinitivaConsolidada(this.osaExecucaoId)
      .then((res) => {
        if (res?.sucesso && res?.dados) {
          this.matrizDefinitivaConsolidada = res.dados;
          this.mostrarSecaoConsolidada = true;

          const secoes = this.matrizDefinitivaConsolidada.secoes || [];
          this.secoesConsolidadasVM = secoes.map((s, idx) => {
            const itens = s.itensFinalizados || [];
            return {
              ...s,
              headingId: `heading-consolidada-ug-${idx}`,
              collapseId: `collapse-consolidada-ug-${idx}`,
              dataSource: new MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>(itens),
              semDados: itens.length === 0
            };
          });
        } else {
          this.resetarConsolidada();
        }
      })
      .catch(() => this.resetarConsolidada());
  }

  // Mantém carregarDados original para outros usos no componente
  private executarGeracaoMatrizConsolidada(): void {
    this.matrizConstatacoesService.gerarMatrizConsolidada(this.osaExecucaoId)
      .then((res) => {
        if (res && res.sucesso) {
          this.exibirSucesso('Matriz Consolidada gerada com sucesso');
          this.carregarMatrizDefinitivaConsolidada();
        } else {
          this.exibirAviso(res?.mensagem?.descricao || 'Erro ao gerar Matriz Consolidada');
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao gerar Matriz Consolidada');
      });
  }

  public visualizarMatrizConsolidada(): void {
    if (!this.matrizDefinitivaConsolidada?.matrizConsolidadaId) {
      this.exibirAviso('Matriz Consolidada não encontrada');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-visualizar-matriz-consolidada';
    dialogConfig.width = '95%';
    dialogConfig.height = '95vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.data = {
      titulo: '',
      matrizId: this.matrizDefinitivaConsolidada.matrizConsolidadaId,
      tipoMatriz: 'consolidada',
      osaExecucaoId: this.osaExecucaoId,
      numeroOsa: this.sharedService.getNumeroOsa(),
      secoes: this.matrizDefinitivaConsolidada.secoes  // ✅ passa as seções
    };

    this.matDialog.open(ModalVisualizarMatrizComponent, dialogConfig);
  }

  public verHistoricoMatrizPorId(matrizId: number, titulo: string, idFuncionalidade: number = 42): void {
    if (!matrizId) {
      this.exibirAviso('Matriz não encontrada');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-matriz';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: matrizId,
      identificador: titulo,
      idFuncionalidade: idFuncionalidade
    };

    const modal = this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) this.carregarDados();
    });
  }

  public verHistoricoMatrizDefinitiva(element?: IMatrizConstatacaoModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-definitiva';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.osaExecucaoId,
      identificador: 'Matriz Constatação Definitiva',
      idFuncionalidade: 42
    };

    const modal = this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) this.carregarDados();
    });
  }

  imprimir(): void {
    if (!this.matrizDefinitivaConsolidada?.matrizConsolidadaId) {
      this.exibirAviso('Matriz Consolidada não encontrada');
      return;
    }

    this.router.navigate(
      [`/imprimir-matriz-constatacao/${this.matrizDefinitivaConsolidada.matrizConsolidadaId}/imprimir`],
      {
        queryParams: { osaExecucaoId: this.osaExecucaoId },
        state: {
          secoes: this.matrizDefinitivaConsolidada.secoes,
          numeroOsa: this.sharedService.getNumeroOsa()
        }
      }
    );
  }

  public verHistoricoMatrizConsolidada(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-consolidada';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: this.osaExecucaoId,
      identificador: 'Matriz Definitiva Consolidada',
      idFuncionalidade: 43
    };

    this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
  }

  public visualizarItemConsolidado(item: IOsaExecucaoMatrizConstatacaoItemModel): void {
    this.editarItemDefinitivo(item, true);
  }

  public excluirMatrizConsolidada(): void {
    const matrizId = this.matrizDefinitivaConsolidada?.matrizConsolidadaId;

    if (!matrizId) {
      this.exibirAviso('Matriz Consolidada não encontrada');
      return;
    }

    Swal.fire({
      title: 'Excluir Matriz Consolidada',
      text: 'Deseja realmente excluir a Matriz Consolidada?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.matrizConstatacoesService.excluirMatrizConsolidada(matrizId)
          .then((res) => {
            if (res && res.sucesso) {
              this.exibirSucesso('Matriz Consolidada excluída com sucesso');
              this.carregarDados(); // ✅ recarrega tudo, inclusive matrizDefinitiva com isExisteConsolidada atualizado
            } else {
              this.exibirAviso(res?.mensagem?.descricao || 'Erro ao excluir Matriz Consolidada');
            }
          })
          .catch((err) => {
            this.exibirErro(err?.mensagem?.descricao || 'Erro ao excluir Matriz Consolidada');
          });
      }
    });
  }

  // ==================== HISTÓRICO ====================

  public verHistorico(element?: IManifestacaoAuditadoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-item-manifestacao';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.id,
      identificador: 'Manifestação do Auditado',
      idFuncionalidade: 39
    };

    const modal = this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) this.carregarDados();
    });
  }

  // ✅ CORRIGIDO: recebe tipoMatriz para separar histórico Preliminar (38) e Definitiva (42)
  public verHistoricoConstatacao(
    element?: IOsaExecucaoMatrizConstatacaoItemModel,
    tipoMatriz: 'preliminar' | 'definitiva' | 'consolidada' = 'preliminar'
  ) {
    // Consolidada exibe o histórico da Definitiva (mesma funcionalidade = 42)
    const idFuncionalidade = tipoMatriz === 'preliminar' ? 38 : 42;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-item';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.osaExecucaoProgramaTrabalhoQuestaoConstatacaoId, // ✅ chave estável entre regenerações
      identificador: element?.identificador,
      idFuncionalidade: idFuncionalidade
    };

    const modal = this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) this.carregarDados();
    });
  }

  public verHistoricoMatriz(element?: IMatrizConstatacaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-aba-matriz-constatacao-preliminar';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: this.osaExecucaoId || element?.osaExecucaoId,
      identificador: 'Matriz Constatação Preliminar',
      idFuncionalidade: 37
    };

    const modal = this.matDialog.open(ModalHistoricoMatrizConstatacaoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) this.carregarDados();
    });
  }

  aprovarManifestacao(element: IManifestacaoAuditadoModel): void {
    // Lógica para aprovar
  }

  // ==================== AUXILIARES ====================

  public getStatusClass(status: any): string {
    if (!status) return '';

    switch (status) {
      case StatusConstatacao.NaoIniciada:
      case StatusMatriz.NaoIniciada:
      case StatusManifestacao.NaoIniciada:
        return 'badge bg-secondary text-xs';

      case StatusConstatacao.EmElaboracao:
      case StatusMatriz.EmElaboracao:
      case StatusManifestacao.EmElaboracao:
        return 'badge bg-success text-xs';

      case StatusConstatacao.Finalizada:
      case StatusMatriz.Finalizada:
        return 'badge bg-warning text-xs';

      case StatusMatriz.Aprovada:
        return 'badge bg-primary text-xs';

      case StatusManifestacao.Enviado:
        return 'badge bg-warning text-xs';

      case StatusManifestacao.ComSugestoesAcatadas:
      case StatusManifestacao.ComSugestoesNaoAcatadas:
      case StatusManifestacao.SemSugestoes:
        return 'badge bg-info text-xs';

      case StatusConstatacao.Cancelada:
        return 'badge bg-danger text-xs';

      default:
        return 'badge bg-secondary text-xs';
    }
  }

  public podeEditarConstatacaoPreliminar(): boolean {
    if (this.visualizar) return false;
    if (!this.selectedConstatacaoPreliminar) return false;
    if (!this.podePlanejar) return false;
    const statusPermitidos = [StatusConstatacao.NaoIniciada, StatusConstatacao.EmElaboracao];
    return statusPermitidos.includes(this.selectedConstatacaoPreliminar.status);
  }

  public podeAprovar(): boolean {
    if (!this.podeAprovarMatriz) return false;
    if (!this.matrizPreliminar) return false;
    return this.matrizPreliminar.status === 3;
  }

  public podeEditarManifestacao(): boolean {
    if (this.visualizar) return false;
    if (!this.manifestacaoAuditado) return false;
    if (!this.podePlanejar) return false;
    const statusPermitidos = [
      StatusManifestacao.NaoIniciada,
      StatusManifestacao.EmElaboracao,
      StatusManifestacao.Enviado
    ];
    return statusPermitidos.includes(this.manifestacaoAuditado.status);
  }

  public podeAvaliarManifestacao(): boolean {
    if (!this.podePlanejar) return false;
    if (!this.manifestacaoAuditado) return false;
    return (
      this.manifestacaoAuditado.status === StatusManifestacao.Enviado ||
      this.manifestacaoAuditado.status === StatusManifestacao.ComSugestoesAcatadas ||
      this.manifestacaoAuditado.status === StatusManifestacao.ComSugestoesNaoAcatadas ||
      this.manifestacaoAuditado.status === StatusManifestacao.SemSugestoes
    );
  }

  public podeEditarConstatacaoDefinitiva(): boolean {
    if (this.visualizar) return false;
    if (!this.selectedConstatacaoDefinitiva) return false;
    if (!this.podePlanejar) return false;
    if (this.matrizConsolidada) return false;
    const statusPermitidos = [StatusConstatacao.NaoIniciada, StatusConstatacao.EmElaboracao];
    return statusPermitidos.includes(this.selectedConstatacaoDefinitiva.status);
  }

  public podeCancelarConstatacaoDefinitiva(): boolean {
    if (this.visualizar) return false;
    if (!this.selectedConstatacaoDefinitiva) return false;
    if (!this.podePlanejar) return false;
    if (this.matrizConsolidada) return false;
    return this.selectedConstatacaoDefinitiva.status !== StatusConstatacao.Cancelada;
  }

  public podeAtivarConstatacaoDefinitiva(): boolean {
    if (this.visualizar) return false;
    if (!this.selectedConstatacaoDefinitiva) return false;
    if (!this.podePlanejar) return false;
    if (this.matrizConsolidada) return false;
    return this.selectedConstatacaoDefinitiva.status === StatusConstatacao.Cancelada;
  }

  private exibirSucesso(mensagem: string): void {
    Swal.fire({
      toast: true, position: 'top-end', icon: 'success',
      text: mensagem, showConfirmButton: false, timer: 5000, timerProgressBar: true
    });
  }

  private exibirAviso(mensagem: string): void {
    Swal.fire({
      toast: true, position: 'top-end', icon: 'warning',
      text: mensagem, showConfirmButton: false, timer: 5000, timerProgressBar: true
    });
  }

  private exibirErro(mensagem: string): void {
    Swal.fire({
      toast: true, position: 'top-end', icon: 'error',
      text: mensagem, showConfirmButton: false, timer: 5000, timerProgressBar: true
    });
  }

  public readonly StatusManifestacaoAuditado = StatusManifestacaoAuditado;
}
